'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setStream;

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setStream(playerId, newStreamId) {
  return function (dispatch, getState) {
    var playback = _store2.default.getPlayerInstance(playerId);
    var _getState$players$pla = getState().players[playerId],
        currentTimeMs = _getState$players$pla.currentTimeMs,
        playables = _getState$players$pla.playables,
        playingIndex = _getState$players$pla.playingIndex;


    var previousPlayerDuration = playback.duration * 1000;

    var currentPlayable = playables.get(playingIndex);
    var nextStream = currentPlayable.streams.find(function (s) {
      return s.id === newStreamId;
    });
    var playbackPlayable = { src: nextStream.src };

    if (playables.size > 1) {
      playback.playables.remove(playingIndex);
      playback.playables.insert(playbackPlayable, playingIndex);
      playback.playingIndex = playingIndex;
    } else {
      playback.playables = [playbackPlayable];
    }

    var playerDuration = void 0;
    if (!isNaN(playback.duration)) {
      playerDuration = playback.duration * 1000;
    } else {
      playerDuration = previousPlayerDuration;
    }

    var timeToSet = currentTimeMs;
    if (timeToSet > playerDuration) {
      timeToSet = 0;
    }

    dispatch({
      type: _constants.SET_STREAM,
      playerId: playerId,
      selectedStreamId: newStreamId,
      seekToTime: timeToSet
    });
  };
}
module.exports = exports['default'];